type TUserAgentData = {
 brands?: { brand: string; version: string }[]
 mobile?: boolean
}

// Chromium-based browsers and in-app webviews that also put "Chrome/" in their UA
const NON_CHROME_UA =
 /Edg|OPR|Opera|SamsungBrowser|YaBrowser|Vivaldi|Brave|UCBrowser|CriOS|FxiOS|EdgiOS|; wv\)|FBAN|FBAV|Instagram|Line\//i

const MOBILE_UA = /Android|iPhone|iPad|iPod|Mobile|Tablet/i

type TNavigator = Navigator & { userAgentData?: TUserAgentData }

// True on phones and tablets, whatever the browser
export const isMobileDevice = (): boolean => {
 if (typeof navigator === 'undefined') return false
 const { userAgentData } = navigator as TNavigator
 if (typeof userAgentData?.mobile === 'boolean') return userAgentData.mobile
 return MOBILE_UA.test(navigator.userAgent)
}

// The web app is only tested on Google Chrome for desktop (AR0547)
export const isSupportedBrowser = (): boolean => {
 if (typeof navigator === 'undefined') return true

 const uaData = (navigator as TNavigator).userAgentData

 // Client hints give the real brand: Edge, Brave and Opera report their own name
 if (uaData?.brands?.length) {
  const isChrome = uaData.brands.some((b) => b.brand === 'Google Chrome')
  return isChrome && !uaData.mobile
 }

 // Fallback for browsers without client hints (Safari, Firefox, older Chrome)
 const ua = navigator.userAgent
 const isChrome =
  /Chrome\//.test(ua) &&
  navigator.vendor === 'Google Inc.' &&
  !NON_CHROME_UA.test(ua)
 return isChrome && !MOBILE_UA.test(ua)
}
